import Product from "../../../../../@types/Product";

const LiftKitsX2: Product[] = [
    {
        id: 1,
        name: 'Non-lifted',
        sku: 'NL',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/liftkit/nonlifted.jpg`,
        price: 0.00,
        retailPrice: 0.00,
    },
    {
        id: 2,
        name: 'Lifted',
        sku: 'L',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/liftkit/lifted.jpg`,
        price: 300.00,
        retailPrice: 500.00,
    }
]

const LiftKitsX4: Product[] = [
    {
        id: 1,
        name: 'Non-lifted',
        sku: 'NL',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/liftkit/nonlifted.jpg`,
        price: 0.00,
        retailPrice: 0.00,
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/74f5be48-9dae-4266-f889-1a22cb549800'
    },
    {
        id: 2,
        name: 'Lifted',
        sku: 'L',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/liftkit/lifted.jpg`,
        price: 300.00,
        retailPrice: 500.00,
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/4e013168-eea4-4bfa-5854-213cc90f3a00'
    },
]

const LiftKitsX6: Product[] = [
    {
        id: 1,
        name: 'Non-lifted',
        sku: 'NL',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/liftkit/nonlifted.jpg`,
        price: 0.00,
        retailPrice: 0.00,
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/0b37e86b-cabc-441e-efdd-19df0715b000'
    },
    {
        id: 2,
        name: 'Lifted',
        sku: 'L',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/liftkit/lifted.jpg`,
        price: 300.00,
        retailPrice: 500.00,
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/2c8330be-7452-44dd-d157-2d662edabf00'
    },
]

export { LiftKitsX2, LiftKitsX4, LiftKitsX6 };